import { AfterViewInit, Directive, OnDestroy, SkipSelf } from "@angular/core";
import { List } from "immutable";
import { Subscription } from "rxjs";
import { IOnModelChange } from "../../common-form.interface";
import { CommonFieldManagerDirective } from "../../field-manager.directive";
import { FieldStateService } from "../../field-state.service";

@Directive({
    selector: "[common-fileupload-actions]",
    exportAs: "FileUploadActions",
})
export class CommonFileUploadActionsDirective implements IOnModelChange, AfterViewInit, OnDestroy {
    public fieldStateSubscriber$: Subscription;

    constructor(
        @SkipSelf() public fieldManager: CommonFieldManagerDirective,
        public fieldStateService: FieldStateService,
    ) { }

    public ngAfterViewInit() {
        this.fieldStateSubscriber$ = this.fieldStateService.stateObservable$.subscribe((state) => {
            this.fieldManager.dispatchFormFieldChange(state.value);
        });
    }

    public ngOnDestroy() {
        this.fieldStateSubscriber$.unsubscribe();
    }

    public get stateProp() {
        return this.fieldManager.context.stateProp;
    }

    public onModelChange(e) {
        const inputEl = e.target;
        const files: List<File> = List<File>(inputEl.files);
        inputEl.value = null;
        this.fieldStateService.dispatchAddValueToStaging(files.toJS());
    }

    public removeFileFromStaging(fileIndex) {
        this.fieldStateService.dispatchRemoveValueFromStaging(fileIndex);
    }
}
